import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Modal from 'components/Modal'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'
import { ButtonContainer, screenSize } from 'styles/shared'

type Props = {
    onCloseCallback: () => void
  }

const RemoteAccessLinkSystemsModal = ({ onCloseCallback }: Props) => {
  const title = 'HOW TO REQUEST REMOTE ACCESS FOR ' + Brand.brandName().toUpperCase() + ' LINK EQUIPMENT'

  return (
    <Modal variant="xl" isDisplayed title={title} closeCallback={onCloseCallback}>

      <S.Container>

        <S.Box>
          <S.CircledNumber>1</S.CircledNumber>
          <S.Text>ACCESS REMOTE SESSION ON THE {Brand.brandName().toUpperCase()} TECHNICIAN MOBILE APP.</S.Text>
          <S.Description>Scan the QR code to download the app.</S.Description>
          {
            Brand.brandName().toUpperCase() === 'TRANE®'
              ? <S.QRImage src={'/img/trane_QR.png'} alt={'Trane QR Code Image'} />
              : <S.QRImage src={'/img/AS_QR.png'} alt={'American Standard QR Code Image'} />
          }
        </S.Box>

        <S.Box>
          <S.CircledNumber>2</S.CircledNumber>
          <S.Text>USE CUSTOMER SEARCH TO FIND THE LINK SYSTEM</S.Text>
          <S.Description>Enter AUID in Customer Search and select the system.</S.Description>
          <S.Image src={'/img/customer_page.png'} alt={'Customers Page Image'} />
        </S.Box>

        <S.Box>
          <S.CircledNumber>3</S.CircledNumber>
          <S.Text>REQUEST REMOTE ACCESS</S.Text>
          <S.Description>'Request Remote Access Permission' is available from the Dashboard.</S.Description>
          <S.Image src={'/img/dashboard.png'} alt={'Dashboard Image'} />
        </S.Box>

      </S.Container>

      <ButtonContainer noBorder>
        <Button decoration="positive" text="Ok" onPress={onCloseCallback} />
      </ButtonContainer>
    </Modal>
  )
}

export default RemoteAccessLinkSystemsModal

const ImageStyle = () => {
  return css`
    margin: 0 auto;
    display: block;
    width: 75%;
  `
}

const S = {
  Container: styled.div`
    display: flex;
    margin-top: 30px;
    gap: 30px;

    @media ${screenSize.small} {
     flex-direction: column;
    }
  `,
  Box: styled.div`
    flex: 100;
    background-color: ${color('modalGridBackground')};
    padding-bottom: 30px;
  `,
  CircledNumber: styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid ${color('modalTitle')};
    color: ${color('modalTitle')};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin:30px;

    @media ${screenSize.small} {
      font-size: 21px;
     }
  `,
  Text: styled.h2`
    font-size: 25px;
    font-family: inter.bold;
    color: ${color('modalText')};
    margin: 30px 30px 5px 30px;

    @media ${screenSize.small} {
      font-size: 21px;
     }
  `,
  Description: styled.p`
    font-size: 17px;
    color: ${color('modalText')};
    margin: 5px 30px 30px 30px;

    @media ${screenSize.small} {
      font-size: 14px;
     }
  `,
  Image: styled.img`
    ${ImageStyle()}
  `,
  QRImage: styled.img`
    ${ImageStyle()}
    max-width: 180px;
  `
}
